export enum ApiOperation {
    AccountValueOverride = "accountValueOverride",
    ActivateBudgetYear = "activateBudgetYear",
    AddUnitType = "addUnitType",
    BulkAddDrivers = "bulkAddDrivers",
    BulkUpdateAccPercentageDriverAssumptions = "bulkUpdateAccPercentageDriverAssumptions",
    CreateUser = "createUser",
    DeleteAccountValueOverrides = "deleteAccountValueOverrides",
    DeleteUnitType = "deleteUnitType",
    DeleteUsers = "deleteUsers",
    SetDrivers = "setDrivers",
    SetOperationalMonthlyAverageCustomIncreases = "setOperationalMonthlyAverageCustomIncreases",
    SetOriginalRevenueInPlaceRentOverrides = "setOriginalRevenueInPlaceRentOverrides",
    SetOriginalRevenueMarketRentAdjustmentsGranular = "setOriginalRevenueMarketRentAdjustmentsGranular",
    SetOriginalRevenueMarketRentMode = "setOriginalRevenueMarketRentMode",
    SetOriginalRevenueMarketRentOverridesGranular = "setOriginalRevenueMarketRentOverridesGranular",
    SetOriginalRevenuePropertyRenewalIncreasePercent = "setOriginalRevenuePropertyRenewalIncreasePercent",
    SetPropertyDrivers = "setPropertyDrivers",
    SetUnitTypePMSOverrides = "setUnitTypePMSOverrides",
    SetBudgetApproval = "setBudgetApproval",
    SubmitBulkSetAssumptions = "submitBulkSetAssumptions",
    SubmitCopyDrivers = "submitCopyDrivers",
    UpdateAccPercentageDriverAssumptions = "updateAccPercentageDriverAssumptions",
    UpdateManualProperty = "updateManualProperty",
    UpdateOperationalDriverAssumptions = "updateOperationalDriverAssumptions",
    UpdateReforecastStartMonth = "updateReforecastStartMonth",
    UpdateUnitType = "updateUnitType",
    UpdateUser = "updateUser",
    UpsertAccountValues = "upsertAccountValues",
    UpsertOpMetricValues = "upsertOpMetricValues",
    UpsertUnitTypeScheduleValues = "upsertUnitTypeScheduleValues",
    DeleteRenovationCostCategories = "deleteRenovationCostCategories",
    CreateRenovationCostCategory = "createRenovationCostCategory",
    UpdateRenovationCostCategory = "updateRenovationCostCategory",
    UpdateWorksheetDriverData = "updateWorksheetDriverData",
}

export const API_MAPPINGS: Record<string, string> = {
    [ApiOperation.AccountValueOverride]: "Account Value - Add Override",
    [ApiOperation.ActivateBudgetYear]: "Change Budget Year",
    [ApiOperation.AddUnitType]: "Unit Type - Add",
    [ApiOperation.BulkAddDrivers]: "Drivers - Bulk Add",
    [ApiOperation.BulkUpdateAccPercentageDriverAssumptions]: "Driver Account Percentage -  Set Values All Sources",
    [ApiOperation.CreateUser]: "User - Create",
    [ApiOperation.DeleteAccountValueOverrides]: "Account Value - Remove Override",
    [ApiOperation.DeleteUnitType]: "Unit Type - Delete",
    [ApiOperation.DeleteUsers]: "User - Delete",
    [ApiOperation.SetDrivers]: "Drivers - Set for Account",
    [ApiOperation.SetOperationalMonthlyAverageCustomIncreases]: "Driver Op Monthly Avg  Set Monthly Increase",
    [ApiOperation.SetOriginalRevenueInPlaceRentOverrides]: "Unit Type - Set IPR Overrides",
    [ApiOperation.SetOriginalRevenueMarketRentAdjustmentsGranular]: "Revenue - Set Market Rent Monthly Growth Values",
    [ApiOperation.SetOriginalRevenueMarketRentMode]: "Revenue - Set Market Rent Growth/Manual",
    [ApiOperation.SetOriginalRevenueMarketRentOverridesGranular]: "Revenue - Market Rent Growth Unit Type Override",
    [ApiOperation.SetOriginalRevenuePropertyRenewalIncreasePercent]: "Revenue - Set Renewal Increase Type",
    [ApiOperation.SetPropertyDrivers]: "Drivers - Set for Multiple Accounts",
    [ApiOperation.SetUnitTypePMSOverrides]: "Unit Type - Overrides",
    [ApiOperation.SetBudgetApproval]: "Budget Approval - Set",
    [ApiOperation.SubmitBulkSetAssumptions]: "Revenue - Bulk Set Assumptions",
    [ApiOperation.SubmitCopyDrivers]: "Drivers - Copy Between Properties Job",
    [ApiOperation.UpdateAccPercentageDriverAssumptions]: "Driver Account Percentage - Set Values",
    [ApiOperation.UpdateManualProperty]: "Property Update",
    [ApiOperation.UpdateOperationalDriverAssumptions]: "Driver Operational - Set Values",
    [ApiOperation.UpdateReforecastStartMonth]: "Change Property Reforecast Month",
    [ApiOperation.UpdateUnitType]: "Unit Type - Update",
    [ApiOperation.UpdateUser]: "User - Update",
    [ApiOperation.UpsertAccountValues]: "Account Value - Set Manual Value",
    [ApiOperation.UpsertOpMetricValues]: "Revenue - Update Early Terms & MTM Move Outs",
    [ApiOperation.UpsertUnitTypeScheduleValues]: "Revenue - Set Unit Type Values",
    [ApiOperation.DeleteRenovationCostCategories]: "Renovation Cost Categories - Delete",
    [ApiOperation.CreateRenovationCostCategory]: "Renovation Cost Categories - Create",
    [ApiOperation.UpdateRenovationCostCategory]: "Renovation Cost Categories - Update",
    [ApiOperation.UpdateWorksheetDriverData]: "Worksheet Line - Update",
};

export function mapApiName(apiName: string): string {
    return API_MAPPINGS[apiName] ?? apiName;
}